import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { defaultTemplate } from "common/hoc";
import { MrbButton } from "mrb";

function TrialActivatedModalModalTemplate({ modalParams, t }) {
    return (
        <MrbModal
            className="modal__content modal__content--lrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={true}
            displayCloseIcon={true}
        >
            <div>
                <div className="modal__icon">
                    <i className="u-icon u-icon--radio-lrg"></i>
                </div>
                <div className="modal__header">
                    <h2>{t("APPLICATION.PREMIUM.TRIAL.ACTIVATE_SUCCESS.TITLE")}</h2>
                </div>

                <p className="u-type--center">{t("APPLICATION.PREMIUM.TRIAL.ACTIVATE_SUCCESS.DESCRIPTION")}</p>

                <div className="c-card--sml c-card--secondary u-mar--top--sml">
                    <p className="u-type--base u-mar--bottom--tny">
                        {t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.APP.DOWNLOAD_APP")}
                    </p>
                    <div className="u-display--flex u-display--flex--jc--space-between">
                        <MrbButton
                            label={t("APPLICATION.PREMIUM.TRIAL.ACTIVATE_SUCCESS.APP_STORE")}
                            onClick={() => {
                                window.open(
                                    "https://apps.apple.com/us/app/naki-go/id1612244728",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        />

                        <MrbButton
                            label={t("APPLICATION.PREMIUM.TRIAL.ACTIVATE_SUCCESS.PLAY_STORE")}
                            onClick={() => {
                                window.open(
                                    "https://play.google.com/store/apps/details?id=com.nakiradio.mobile&hl=en",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
        </MrbModal>
    );
}

TrialActivatedModalModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(TrialActivatedModalModalTemplate);
